// Daily report slice for Redux Toolkit
//
// Mirrors searchSlice.js: the date range and loaded report data live here
// (not component useState) specifically so navigating Daily Report -> Viewer
// -> back restores the previous report instead of wiping it and forcing
// another API call. The Daily Report page is responsible for calling
// clearDailyReport() when the user navigates away to anywhere other than a
// viewer (see DailyReport.js's unmount effect) - this slice only stores
// whatever it's told to.
//
// Dates are stored as ISO strings, not Date objects, since Redux state must
// be serializable.

import { createSlice } from '@reduxjs/toolkit';

const defaultStartDate = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today.toISOString();
};

const defaultEndDate = () => new Date().toISOString();

const initialState = {
  startDate: defaultStartDate(),
  endDate: defaultEndDate(),
  reportData: null
};

const dailyReportSlice = createSlice({
  name: 'dailyReport',
  initialState,
  reducers: {
    setDailyReportRange: (state, action) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },
    setDailyReportData: (state, action) => {
      state.reportData = action.payload;
    },
    clearDailyReport: (state) => {
      state.startDate = defaultStartDate();
      state.endDate = defaultEndDate();
      state.reportData = null;
    }
  }
});

export const { setDailyReportRange, setDailyReportData, clearDailyReport } = dailyReportSlice.actions;
export default dailyReportSlice.reducer;

// Selectors
export const selectDailyReportStartDate = (state) => state.dailyReport.startDate;
export const selectDailyReportEndDate = (state) => state.dailyReport.endDate;
export const selectDailyReportData = (state) => state.dailyReport.reportData;
